import React, { useState } from 'react';
import { calculateElements } from '../utils/calculateElements';
import Vidrios from './Vidrios';
import './VentanaCalculator.css';
import BarraVisualizer from './BarraVisualizer';
import HeightWarningModal from './HeightWarningModal';

const AccordionItem = ({ title, children }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="accordion-item table-sm" style={{ 
      marginBottom: '10px', 
      border: '1px solid #dee2e6', 
      borderRadius: '4px',
      fontSize: '0.875rem'
    }}>
      <div 
        className="accordion-header text-nowrap" 
        onClick={() => setIsOpen(!isOpen)}
        style={{
          padding: '8px 12px',
          backgroundColor: '#f8f9fa',
          cursor: 'pointer',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderRadius: isOpen ? '4px 4px 0 0' : '4px'
        }}
      >
        <span style={{ margin: 0, fontWeight: 'normal' }}>{title}</span>
        <span style={{ 
          transform: isOpen ? 'rotate(90deg)' : 'rotate(0deg)',
          transition: 'transform 0.3s ease',
          display: 'inline-block'
        }}>
          ▶
        </span>
      </div>
      {isOpen && (
        <div className="accordion-content" style={{ padding: '12px' }}>
          {children}
        </div>
      )}
    </div>
  );
};

const VentanaCalculator = () => {
  const [width, setWidth] = useState('');
  const [height, setHeight] = useState('');
  const [elements, setElements] = useState({});
  const [windowType, setWindowType] = useState('');
  const [additionalMeasure, setAdditionalMeasure] = useState('');
  const [showHeightWarning, setShowHeightWarning] = useState(false);
  const [pendingCalculation, setPendingCalculation] = useState(null);

  const handleCalculate = () => {
    const parsedWidth = Number(width);
    const parsedHeight = Number(height);
    const parsedAdditionalMeasure = Number(additionalMeasure);

    if (windowType === 'correderaChica' && parsedHeight > 1601) {
      setShowHeightWarning(true);
      setPendingCalculation({ width: parsedWidth, height: parsedHeight });
      return;
    }

    performCalculation(parsedWidth, parsedHeight, parsedAdditionalMeasure);
  };

  const performCalculation = (parsedWidth, parsedHeight, parsedAdditionalMeasure) => {
    const result = calculateElements(
      windowType, 
      parsedWidth, 
      parsedHeight, 
      parsedAdditionalMeasure
    );
    
    console.log('Resultado del cálculo:', result);
    
    if (result) {
      setElements(result);
    }
  };

  const handleWarningConfirm = () => {
    setShowHeightWarning(false);
    if (pendingCalculation) {
      performCalculation(
        pendingCalculation.width, 
        pendingCalculation.height, 
        Number(additionalMeasure)
      );
    }
    setPendingCalculation(null);
  };

  const handleWarningCancel = () => {
    setShowHeightWarning(false);
    setPendingCalculation(null);
  };

  return (
    <div className="ventana-calculator">
      <div className="logo-container">
        <img
          src="https://superfil.cl/wp-content/uploads/2020/04/LOGOLOGO-SUPERFIL-2020.png"
          alt="Logo"
          className="logo"
          style={{ width: '150px', marginBottom: '10px' }}
        />
      </div>
      <h2>Pauta de Cortes Superfil</h2>
      <div className="input-group form-control" style={{ display: 'flex', alignItems: 'center' }}>
        <label htmlFor="width" style={{ marginRight: '34px' }}>
          Ancho:
        </label>
        <div style={{ flex: '1', marginRight: '9px' }}>
          <input
            type="number"
            placeholder="Ancho en milimetros"
            id="width"
            value={width}
            onChange={(e) => setWidth(e.target.value)}
            style={{ width: '100%', height: '30px' }}
            inputMode="numeric"
          />
        </div>
      </div>
      <div className="input-group form-control" style={{ display: 'flex', alignItems: 'center' }}>
        <label htmlFor="height" style={{ marginRight: '50px' }}>
          Alto:
        </label>
        <div style={{ flex: '1', marginRight: '9px' }}>
          <input
            type="number"
            placeholder="Alto en milimetros"
            id="height"
            value={height}
            onChange={(e) => setHeight(e.target.value)}
            style={{ width: '100%', height: '30px' }}
            inputMode="numeric"
          />
        </div>
      </div>

      <div className="input-group form-control" style={{ display: 'flex', alignItems: 'center' }}>
        <label htmlFor="windowType" style={{ marginRight: '10px' }}>
          Tipo de ventana:
        </label>
        <div style={{ flex: '1', marginRight: '9px' }}>
          <select
            id="windowType"
            value={windowType}
            onChange={(e) => setWindowType(e.target.value)}
            style={{ width: '100%', height: '30px' }}
          >
            <option value="">Seleccionar</option>
            <option value="correderaChica">Corredera Chica</option>
            <option value="correderaGrande">Corredera Grande</option>
            <option value="marcoFijo">Marco Fijo</option>
            <option value="proyectanteExterior">Proyectante Exterior</option>
            <option value="puertaExterior">Puerta Exterior</option>
            <option value="proyectanteFijo">Proyectante + Fijo (palillo)</option>
            <option value="monorielAmericano">Monoriel Americana</option>
            <option value="doblerielAmericano">Doble Riel Americana</option>
          </select>
        </div>
      </div>

      {windowType === 'proyectanteFijo' && (
        <div className="input-group form-control" style={{ display: 'flex', alignItems: 'center' }}>
          <label htmlFor="additionalMeasure" style={{ marginRight: '10px' }}>
            Ancho Proyectante:
          </label>
          <div style={{ flex: '1', marginRight: '9px' }}>
            <input
              type="number"
              placeholder="Ancho Proyectante en milímetros"
              id="additionalMeasure"
              value={additionalMeasure}
              onChange={(e) => setAdditionalMeasure(e.target.value)}
              style={{ width: '100%', height: '30px' }}
              inputMode="numeric"
            />
          </div>
        </div>
      )}

      <button onClick={handleCalculate}>Calcular elementos</button>
      {elements && Object.keys(elements).length > 0 && (
        <div className="results">
          <div>{elements.type}</div>
          {elements.photo && (
            <div>
              <img src={elements.photo} alt={elements.type} width="400vh" />
            </div>
          )}
          
          <div className="table-responsive" style={{ marginTop: '20px' }}>
            <h4 style={{ fontSize: '1rem', fontWeight: 'bold' }}>Medidas de Corte</h4>
            <table className="table table-striped table-bordered table-sm">
              <thead>
                <tr>
                  <th>Perfil</th>
                  <th>Ancho</th>
                  <th>Alto</th>
                </tr>
              </thead>
              <tbody>
                {(() => {
                  // Crear un objeto que combine los perfiles
                  const perfilesCombinados = {};
                  
                  // Agregar perfiles horizontales
                  Object.entries(elements.horizontal || {}).forEach(([perfil, valor]) => {
                    perfilesCombinados[perfil] = {
                      ancho: valor,
                      alto: '-'
                    };
                  });
                  
                  // Agregar o actualizar perfiles verticales
                  Object.entries(elements.vertical || {}).forEach(([perfil, valor]) => {
                    if (perfilesCombinados[perfil]) {
                      perfilesCombinados[perfil].alto = valor;
                    } else {
                      perfilesCombinados[perfil] = {
                        ancho: '-',
                        alto: valor
                      };
                    }
                  });
                  
                  // Renderizar las filas combinadas
                  return Object.entries(perfilesCombinados).map(([perfil, medidas]) => (
                    <tr key={perfil}>
                      <td>{perfil}</td>
                      <td>{medidas.ancho} {medidas.ancho !== '-' ? 'mm' : ''}</td>
                      <td>{medidas.alto} {medidas.alto !== '-' ? 'mm' : ''}</td>
                    </tr>
                  ));
                })()}
              </tbody>
            </table>
          </div>

          {elements.barrasNecesarias && Object.keys(elements.barrasNecesarias).length > 0 && (
            <div className="table-responsive" style={{ marginTop: '20px' }}>
              <h4 style={{ fontSize: '1rem', fontWeight: 'bold' }}>Optimización de Barras (6000mm)</h4>
              {Object.entries(elements.barrasNecesarias).map(([perfil, datos]) => (
                <AccordionItem 
                  key={perfil} 
                  title={`${perfil} - ${datos.cantidadBarras} Perfiles (${datos.desperdicioMm} mm sobrantes)`}
                >
                  <BarraVisualizer 
                    largoTotal={datos.largoTotal}
                    piezas={[...datos.piezasVerticales, ...datos.piezasHorizontales]}
                    largoBarra={6000}
                  />
                </AccordionItem>
              ))}
            </div>
          )}
          
          <div>
            <Vidrios 
              ventanaType={windowType} 
              height={parseInt(height)} 
              width={parseInt(width)} 
              additionalMeasure={parseInt(additionalMeasure)} 
            />
          </div>
        </div>
      )}
      <div className="disclaimer-text">
        Todas las medidas están expresadas en milímetros y son de carácter referencial, debe comprobar en su taller las medidas entregadas, Superfil no se hace responsable del mal uso de esta aplicación.
      </div>
      <div>
      <div className="logo-container">
        <img
          src="/PERFILES.png"
          alt="banner"
          className="logo"
          style={{ width: 'auto', marginBottom: '10px' ,marginTop: '10px'}}
        />
      </div>
        <div>Encuentra todos nuestros productos en</div>
        <h3>
          <a href="https://www.superfil.cl" target="_blank" rel="noopener noreferrer">
            www.superfil.cl
          </a>
        </h3>
      </div>
      <HeightWarningModal 
        isOpen={showHeightWarning}
        onConfirm={handleWarningConfirm}
        onCancel={handleWarningCancel}
      />
    </div>
  );
};

export default VentanaCalculator;
